import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useEffect } from 'react';
import { I18nextProvider } from 'react-i18next';
import i18n from '../../i18n';
import { useUserSettingsContext } from '../UserSettings';
export var LocalizationContext = createContext({});
var Provider = function (_a) {
    var children = _a.children;
    var userSettings = useUserSettingsContext().userSettings;
    useEffect(function () {
        i18n.changeLanguage(userSettings === null || userSettings === void 0 ? void 0 : userSettings.lang);
    }, [userSettings === null || userSettings === void 0 ? void 0 : userSettings.lang]);
    return (_jsx(LocalizationContext.Provider, { value: { userSettings: userSettings }, children: _jsx(I18nextProvider, { i18n: i18n, children: children }) }));
};
export default Provider;
